import { createContext, useState, useEffect } from 'react';
import { ThemeProvider as SCThemeProvider } from 'styled-components';

export const ThemeContext = createContext({
  theme: 'dark',
  toggleTheme: () => {},
});

const themes = {
  dark: {
    bg: '#1C1C27',
    bgLight: '#1C1E27',
    primary: '#059669',
    text_primary: '#F2F3F4',
    text_secondary: '#b1b2b3',
    card: '#171721',
    card_light: '#191924',
    button: '#059669',
    white: '#FFFFFF',
    black: '#000000',
  },
  light: {
    bg: '#FFFFFF',
    bgLight: '#f0f0f0',
    primary: '#059669',
    text_primary: '#111111',
    text_secondary: '#48494a',
    card: '#FFFFFF',
    card_light: '#F5F5F5',
    button: '#5c5b5b',
    white: '#FFFFFF',
    black: '#000000',
  },
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);

    const scrollbarColors = themes[theme];
    const style = document.createElement('style');
    style.textContent = `
      ::-webkit-scrollbar {
        width: 8px;
      }
      ::-webkit-scrollbar-track {
        background: ${scrollbarColors.card};
      }
      ::-webkit-scrollbar-thumb {
        background: ${scrollbarColors.primary};
        border-radius: 4px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: ${scrollbarColors.primary}dd;
      }
    `;

    const existingStyle = document.getElementById('theme-scrollbar-styles');
    if (existingStyle) {
      existingStyle.remove();
    }

    style.id = 'theme-scrollbar-styles';
    document.head.appendChild(style);

    return () => {
      const styleToRemove = document.getElementById('theme-scrollbar-styles');
      if (styleToRemove) {
        styleToRemove.remove();
      }
    };
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  const currentTheme = themes[theme];

  return (
    <ThemeContext.Provider
      value={{ theme, toggleTheme, themeObject: currentTheme }}
    >
      <SCThemeProvider theme={currentTheme}>{children}</SCThemeProvider>
    </ThemeContext.Provider>
  );
};
